module.exports = __webpack_public_path__ + "img/lr_15.a6d2882a.png";